exports = module.exports = require("../../../../../../../../../../../../../home/tiger/.nvm/versions/node/v12.4.0/lib/node_modules/@ies/eden/node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".arco-load-more {\n  text-align: center;\n  font-size:  0.28rem ;\n  font-size:  var(--load-more-font-size) ;\n  color:  #86909c ;\n  color:  var(--load-more-text-color) ;\n}\n", ""]);

